/* eslint-disable @nx/enforce-module-boundaries*/
import type { IAppState as DashboardAppState } from '@ps20-frontend/apps/dashboard-store';
import {
  App,
  FeatureToggles,
  isMultistoreApp,
  isTiergruppeActive,
} from '@ps20-frontend/frontend-models';
import {
  AngebotsId,
  GlobalAction,
  GlobalActions,
  GlobalEventDispatcher,
  isAngebotsIdEqual,
  isOwnedByTgv,
  ProduktDeleted,
} from '@ps20-frontend/shop-integration-redux';

export interface StateSnapshotTrigger {
  type: string;
  skipsRollback: boolean;
  snapshottedOffers: AngebotsId[];
}

let latestTrigger: StateSnapshotTrigger | null = null;

export const recordStateSnapshotTrigger = (trigger: StateSnapshotTrigger | null): void => {
  latestTrigger = trigger;
};

export const latestStateSnapshotTrigger = (): StateSnapshotTrigger | null => latestTrigger;

export const offersToRestore = (
  registered: AngebotsId[],
  trigger: StateSnapshotTrigger | null,
): AngebotsId[] =>
  trigger?.snapshottedOffers
    ? registered.filter(offer =>
        trigger.snapshottedOffers.some(snapshotted => isAngebotsIdEqual(snapshotted, offer)),
      )
    : registered;

export const skipsRollbackAfter = (
  trigger: GlobalAction<unknown> | undefined,
  featureToggles: FeatureToggles | null | undefined,
  warenkorb: DashboardAppState['warenkorb'],
  isRegistered: (offer: AngebotsId) => boolean,
): boolean => {
  if (trigger?.type !== GlobalActions.PRODUKT_DELETED) {
    return false;
  }
  const { angebotsIds: deleted } = trigger.payload as ProduktDeleted;
  const removesMultistoreStore = deleted.some(
    offer => isMultistoreApp(offer.appId) && isRegistered(offer),
  );
  const touchesTiergruppe =
    isTiergruppeActive(featureToggles) &&
    deleted.some(
      offer =>
        offer.appId === App.TGV ||
        warenkorb.some(row => isOwnedByTgv(row) && isAngebotsIdEqual(row, offer)),
    );
  return removesMultistoreStore || touchesTiergruppe;
};

export const dashboardWarenkorb = (): DashboardAppState['warenkorb'] => {
  const state = GlobalEventDispatcher.getInstance()
    .findStoreRef(App.SHOP_DASHBOARD)
    ?.store.getState() as Partial<DashboardAppState> | undefined;
  return Array.isArray(state?.warenkorb) ? state.warenkorb : [];
};
